"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _mergeTheme = _interopRequireDefault(require("../style/mergeTheme"));

var _root = _interopRequireDefault(require("./style/root"));

var Paper = function Paper(_ref) {
  var theme = _ref.theme,
      style = _ref.style,
      interactive = _ref.interactive,
      children = _ref.children;
  var memoTheme = (0, _react.useMemo)(function () {
    return (0, _mergeTheme["default"])(theme, style);
  }, [style]);
  return _react["default"].createElement(_root["default"], {
    theme: memoTheme,
    interactive: interactive
  }, children);
};

Paper.propTypes = {
  children: _propTypes["default"].any,
  interactive: _propTypes["default"].bool,
  style: _propTypes["default"].object,

  /**
   * Basic style
   */
  theme: _propTypes["default"].shape({
    /**
     * @default palette.elPrimary
     */
    background: _propTypes["default"].string,

    /**
     * @default palette.gutter * 2
     */
    padding: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),

    /**
     * @default 0 2px 4px 0 ${palette.elShadowLight}, 0 0 4px 0 ${palette.elShadowLight}
     */
    boxShadow: _propTypes["default"].string,

    /**
     * @default 3px
     */
    borderRadius: _propTypes["default"].string,

    /**
     * @default box-shadow ${palette.transitionDuration} ${palette.transitionFunction}
     */
    transition: _propTypes["default"].string,

    /**
     * @default 0 4px 8px 0 ${palette.elShadow}, 0 2px 8px 0 ${palette.elShadow}
     */
    hoverBoxShadow: _propTypes["default"].string
  })
};
Paper.defaultProps = {
  interactive: false
};
var _default = Paper;
exports["default"] = _default;